module.exports = __webpack_public_path__ + "static/media/prata-forst.f0eb8b08.mp3";